import { Stack, Text, useMantineTheme } from "@mantine/core";
import { IconClipboardOff } from "@tabler/icons-react";

type Props = {
  title?: string;
};
export function NoResult({ title }: Props) {
  const theme = useMantineTheme();
  return (
    <Stack align="center" justify="center" mt="lg">
      <IconClipboardOff size={50} color={theme?.colors.gray[2]} />
      <Text
        style={{
          color: theme?.colors.gray[4],
        }}
        size="sm"
      >
        {title ? title : <Text>موردی برای نمایش موجود نیست</Text>}
      </Text>
    </Stack>
  );
}
